import React, { Component } from "react";
import { connect } from "react-redux";
import CancelSVG from "../../../../Assets/svg/CancelButtonSVG.svg";
import PropTypes from "prop-types";
import { withRouterHooks } from "../../../../withRouters/withRoutersHook";
import { SaveContactName } from "../../../../Actions/Messaging";


class SaveContact extends Component {
  constructor(props) {
    super(props);
    this.dialogRef = React.createRef();
    this.state = {
      name: props.initialName || "",
      isSaving: false,
      validationError: "",
    };
  }

  static propTypes = {
    SaveContactName: PropTypes.func.isRequired,
    handleShowSaveContact: PropTypes.func.isRequired,
    location: PropTypes.object,
    navigate: PropTypes.func.isRequired,
    initialName: PropTypes.string,
    isRename: PropTypes.bool,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.initialName !== this.props.initialName) {
      this.setState({
        name: this.props.initialName || "",
        validationError: "",
      });
    }
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  onchange = (e) => {
    this.setState({ name: e.target.value, validationError: "" });
  };

  handleClickOutside = (event) => {
    if (this.dialogRef.current && !this.dialogRef.current.contains(event.target)) {
      this.props.handleShowSaveContact();
    }
  };

  getSessionIdFromPath = () => {
    const { location } = this.props;
    if (!location || !location.pathname) return null;
    return location.pathname.split("/").pop();
  };

  handleSaveContact = async () => {
    const sessionId = this.getSessionIdFromPath();
    if (!this.state.name.trim()) {
      this.setState({ validationError: "Please enter a name before saving." });
      return;
    }

    this.setState({ isSaving: true, validationError: "" });

    try {
      const trimmedName = this.state.name.trim();
      await this.props.SaveContactName(trimmedName, sessionId);
      console.log("Contact saved successfully");

      this.setState({ name: "", isSaving: false });
      this.props.navigate(this.props.location.pathname, {
        replace: true,
        state: {
          ...(this.props.location?.state || {}),
          userName: trimmedName,
        },
      });

      this.props.handleShowSaveContact();
    } catch (error) {
      console.error("Error saving contact:", error);
      this.setState({ isSaving: false });
    }
  };

  render() {
    const { handleShowSaveContact } = this.props;
    const actionLabel = this.props.isRename ? "Rename Contact" : "Save Contact";
    const helperCopy = this.props.isRename
      ? "Update the saved name for this WhatsApp conversation."
      : "Add a contact name for this WhatsApp conversation.";
    const { name, isSaving, validationError } = this.state;

    return (
      <div className="absolute inset-0 z-50 flex items-center justify-center bg-slate-900/30 backdrop-blur-[2px] p-4">
        <div
          ref={this.dialogRef}
          className="w-full max-w-lg overflow-hidden rounded-2xl border border-blue-100 bg-white shadow-[0_20px_60px_rgba(15,23,42,0.18)]"
        >
          <div
            className="flex items-center justify-between border-b border-blue-100 px-6 py-4"
            style={{ background: "linear-gradient(135deg, #ffffff 0%, #eff6ff 100%)" }}
          >
            <div>
              <p className="font-inter text-sm font-semibold uppercase tracking-wider text-gray-700">
                {actionLabel}
              </p>
              <p className="mt-1 font-inter text-sm text-gray-500">
                {helperCopy}
              </p>
            </div>
            <button
              onClick={handleShowSaveContact}
              className="rounded-lg p-2 transition-colors hover:bg-white/70"
              aria-label="Close save contact dialog"
            >
              <img src={CancelSVG} alt="Cancel" className="h-4 w-4" />
            </button>
          </div>

          <div className="space-y-5 px-6 py-6">
            <div>
              <label
                htmlFor="save-contact-name"
                className="mb-2 block font-inter text-xs font-medium uppercase tracking-wider text-gray-500"
              >
                Contact Name
              </label>
              <input
                id="save-contact-name"
                type="text"
                name="name"
                value={name}
                onChange={this.onchange}
                placeholder="Enter contact name"
                className="h-11 w-full rounded-xl border border-gray-200 bg-white px-4 text-sm font-inter text-gray-900 outline-none transition-colors placeholder:text-gray-400 focus:border-primary-blue"
              />
              {validationError && (
                <p className="mt-2 font-inter text-sm text-red-500">
                  {validationError}
                </p>
              )}
            </div>

            <div className="flex items-center justify-end gap-3">
              <button
                type="button"
                onClick={handleShowSaveContact}
                className="inline-flex items-center justify-center rounded-lg border border-gray-200 bg-white px-4 py-2.5 font-inter text-sm font-semibold text-gray-700 transition-colors hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={this.handleSaveContact}
                disabled={isSaving}
                className={`inline-flex min-w-32 items-center justify-center rounded-lg px-4 py-2.5 font-inter text-sm font-semibold text-white transition-all ${
                  isSaving
                    ? "cursor-not-allowed bg-blue-300"
                    : "bg-gradient-to-r from-primary-blue to-blue-400 shadow-sm hover:from-blue-600 hover:to-blue-500"
                }`}
              >
                {isSaving ? "Saving..." : actionLabel}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

export default withRouterHooks(
  connect(mapStateToProps, { SaveContactName })(SaveContact)
);
